var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgFiles = function SvgFiles(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h22v22H0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m3.83 5.085.09.09v.896l-.09.09c-.652 0-1.187.497-1.249 1.133l-.006.121V18.17a1.257 1.257 0 0 0 1.134 1.249l.121.006h10.755a1.257 1.257 0 0 0 1.249-1.134l.006-.121.09-.09h.895l.09.09a2.333 2.333 0 0 1-2.183 2.325l-.147.005H3.83a2.333 2.333 0 0 1-2.325-2.183L1.5 18.17V7.415A2.333 2.333 0 0 1 3.683 5.09l.147-.005zM10.04 1.5c.724 0 1.404.335 1.843.903l.097.135 1.052 1.65h5.138a2.333 2.333 0 0 1 2.325 2.184l.005.147v8.066a2.333 2.333 0 0 1-2.183 2.325l-.147.005H7.415a2.333 2.333 0 0 1-2.325-2.183l-.005-.147V3.83a2.333 2.333 0 0 1 2.183-2.325l.147-.005h2.626zm0 1.075H7.416a1.257 1.257 0 0 0-1.249 1.134l-.006.121v10.755a1.257 1.257 0 0 0 1.134 1.249l.121.006H18.17a1.257 1.257 0 0 0 1.249-1.134l.006-.121V6.519a1.256 1.256 0 0 0-1.134-1.249l-.121-.006h-5.378a.539.539 0 0 1-.392-.17l-.055-.07-1.26-1.89a1.253 1.253 0 0 0-1.044-.559z"
  })));
};

export default SvgFiles;